import { isIFrame } from "@/app/utils/IFrameUtils";
import { StructuredLog } from "@agentx/agentx-services";
import { getIFrameLoginTransactionId } from "./login-transaction-state";
function isWebexAuthCodeMessage(data) {
    if (typeof data !== "object" || data === null) {
        return false;
    }
    const message = data;
    return (message.type === "webex-auth-code" &&
        typeof message.code === "string" &&
        message.code.length > 0 &&
        typeof message.transactionId === "string" &&
        message.transactionId.length > 0 &&
        typeof message.state === "string" &&
        message.state.length > 0);
}
export class IFrameHelper {
    constructor(onLoginError) {
        this.onLoginError = onLoginError;
        this.popupWindow = null;
        this.authCodeReceived = false;
        this.transactionId = crypto.randomUUID();
        this.onAuthCodeMessage = (event) => {
            this.handleAuthCodeMessage(event);
        };
        window.addEventListener("message", this.onAuthCodeMessage);
        this.interceptWindowOpen();
    }
    interceptWindowOpen() {
        // initiateLogin() opens its separate window synchronously, so capture its handle here.
        const originalWindowOpen = Reflect.get(window, "open");
        this.originalWindowOpen = originalWindowOpen.bind(window);
        window.open = (...args) => {
            return this.openLoginPopup(args);
        };
    }
    openLoginPopup(args) {
        try {
            if (!this.originalWindowOpen) {
                throw new Error("Cannot open login popup: original window.open is unavailable");
            }
            this.popupWindow = this.originalWindowOpen(...args);
            this.monitorLoginPopup();
            return this.popupWindow;
        }
        catch (error) {
            this.cleanup();
            throw error;
        }
        finally {
            this.restoreWindowOpen();
        }
    }
    monitorLoginPopup() {
        if (!this.popupWindow) {
            this.cleanup();
            this.onLoginError("loginPopupNotCreated");
            return;
        }
        if (!this.authCodeReceived) {
            this.checkClosedInterval = setInterval(() => {
                this.handlePopupClosed();
            }, 1000);
        }
    }
    handlePopupClosed() {
        if (this.popupWindow?.closed) {
            this.cleanup();
            StructuredLog.trace("Login/EntryUtils/LoginWithWebEx/PopupClosedByUser");
            this.onLoginError("loginCancelled");
        }
    }
    cleanup() {
        this.restoreWindowOpen();
        if (this.onAuthCodeMessage) {
            window.removeEventListener("message", this.onAuthCodeMessage);
            this.onAuthCodeMessage = undefined;
        }
        if (this.checkClosedInterval !== undefined) {
            clearInterval(this.checkClosedInterval);
            this.checkClosedInterval = undefined;
        }
    }
    restoreWindowOpen() {
        if (this.originalWindowOpen) {
            window.open = this.originalWindowOpen;
            this.originalWindowOpen = undefined;
        }
    }
    handleAuthCodeMessage(event) {
        if (event.origin !== window.location.origin || event.source !== this.popupWindow) {
            return;
        }
        const messageData = event.data;
        if (!isWebexAuthCodeMessage(messageData) ||
            messageData.transactionId !== this.transactionId ||
            getIFrameLoginTransactionId(messageData.state) !== this.transactionId) {
            return;
        }
        this.authCodeReceived = true;
        this.cleanup();
        this.popupWindow?.close();
        this.redirectWithAuthCode(messageData);
    }
    redirectWithAuthCode(messageData) {
        const callbackUrl = new URL(window.location.origin);
        callbackUrl.searchParams.set("code", messageData.code);
        callbackUrl.searchParams.set("state", messageData.state);
        StructuredLog.trace("Login/EntryUtils/LoginWithWebEx/AuthorizationCodeReceived");
        window.location.replace(callbackUrl);
    }
}
export function getIFrameHelper(onLoginError) {
    return isIFrame() ? new IFrameHelper(onLoginError) : undefined;
}
